<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import eventBus from '@tools/event-bus';
import { OFFER_EVENT } from '@organisms/offer/constants';
import { Slider } from '@enums/event.ts';
import type { AccountManager } from '@models/accountManager.ts';
import OfferProposal from './Sliders/OfferProposal.vue';
import RefuseSelectionItem from './Sliders/RefuseSelectionItem.vue';

interface RefuseSelectionItemPayload {
  id: number,
  accountManager?: AccountManager,
}

interface AddProposalPayload {
  hashIds: string[],
  teamSize: number | null,
  teamSizeList: number[],
}

type Payload = RefuseSelectionItemPayload | AddProposalPayload;

const currentOpenedComponent = ref<Slider | null>(null);
const payload = ref<Payload | null>(null);

const isOfferProposal = computed<boolean>(() => currentOpenedComponent.value === Slider.CREATE_PROPOSAL);
const isRefuseSelectionItem = computed<boolean>(() => currentOpenedComponent.value === Slider.REFUSE_SELECTION_ITEM);

const close = (): void => {
  currentOpenedComponent.value = null;
};

const sliderShowListener = (event: CustomEvent): void => {
  const { sliderType, sliderPayload } = event.detail as { sliderType: Slider, sliderPayload: Payload };
  currentOpenedComponent.value = sliderType;

  if (!currentOpenedComponent.value) {
    return;
  }

  payload.value = sliderPayload;
};

onMounted(() => {
  eventBus.addEventListener(OFFER_EVENT.SLIDER_SHOW, sliderShowListener);
});

onBeforeUnmount(() => {
  eventBus.removeEventListener(OFFER_EVENT.SLIDER_SHOW, sliderShowListener);
});
</script>

<template>
  <div
    v-if="currentOpenedComponent && payload"
    class="sliders"
  >
    <OfferProposal
      v-if="isOfferProposal"
      :is-opened="isOfferProposal"
      :payload="payload"
      @close="close"
    />

    <RefuseSelectionItem
      v-if="isRefuseSelectionItem"
      :is-opened="isRefuseSelectionItem"
      :payload="payload"
      @close="close"
    />
  </div>
</template>
